import n from"./function-uncurry-this.js";var t=n,i=0,o=Math.random(),a=t(1 .toString),u=function(r){return"Symbol("+(r===void 0?"":r)+")_"+a(++i+o,36)};export{u as default};
